export default {
  title: 'Playturbo',
  payment: {
    button: '购买套餐',
  },
  menu: {
    account: '账户管理',
    template: '我的素材',
    logout: '退出登录',
    subscribeTips: 'Playable Production Tool',
  },
  nav: {
    delivery: '素材汇总',
    index: '定制可玩广告',
    commonTemplate: '可玩广告模板',
    videoImage: '定制图片&视频',
    report: '报表',
  },
  makerSwitch: {
    tools: '选择工具',
    dmaker: '定制创意',
    gmaker: '互动广告制作',
    vmaker: '视频广告制作',
  },
  download: {
    dropdown: ['推送至Mintegral', '下载其他渠道'],
  },
  message: {
    notifications: '系统通知',
    ignoreAll: '忽略全部',
    viewAll: '查看所有消息',
    noNotification: '暂无通知',
  },
}
